import { CSSProperties } from 'react';
import './style.less';
import { Group } from '@/components/_common';

interface Props {
  value: string;
  active: boolean;
  style?: CSSProperties;
  onClick: VoidFunction;
}

export default function ScheduleHourCard(props: Props) {
  return (
    <div
      style={props.style}
      key={props.value}
      data-active={props.active}
      onClick={props.onClick}
      className="schedule-hour-card"
    >
      <Group position="center" style={{ fontWeight: 600 }}>
        {props.value}
      </Group>
    </div>
  );
}
